import React, { Component } from "react";
import commStyles from "../../common/styles";
import { connect } from "react-redux";
import {Container}  from '../../common/components/Container';
import { Table } from "../../common/components/Table";
import { Model } from "../../common/components/Model";
import { ReactSelect } from "../../common/components/ReactSelect";
import apiCall from '../../common/utils/apiCall';
import { toast } from "react-toastify";
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { Link } from "react-router-dom";
import '../../common/styles/styles.css';

const {
  Form,
  FormRow,
  FormColumn,
  FormInput,
  FormInputLabel,
  ButtonWrapper,
  ButtonSecondary,
  ButtonSuccess,
  SubHeading,
} = commStyles;

const columns = [
  { id: 'name', label: 'Name', minWidth: '10%' },
  { id: 'email', label: 'Email', minWidth: '10%' },
  { id: 'accessLevel', label: 'User AccessLevel', minWidth: '10%' },
  { id: 'status', label: 'User Status', minWidth: '10%' },
  { id: 'isUserVerified', label: 'is User Verified', minWidth: '10%' },
  { id: 'userAddresses', label: 'User Addresses', minWidth: '10%' },
  { id: 'createdAt', label: 'created on', minWidth: '10%' },
  { id: 'updatedAt', label: 'updated on', minWidth: '10%' },
  { id: 'operationEditDelete', label: 'Edit / Delete', minWidth: '10%' },
];
const addressColumns = [
  { id: 'address', label: 'Address', minWidth: '10%' },
  { id: 'state', label: 'State', minWidth: '10%' },
  { id: 'pincode', label: 'Pincode', minWidth: '10%' },
];

let mountLimit = 1;
let filterHeight = (document.getElementById('filterDiv'))?`${document.getElementById('filterDiv').offsetHeight}px`:'10vh'

class Users extends Component {

  constructor(props){
    super(props);
    this.state = {
      usersData : [],
      userAddresses : [],
      totalSize : 0,
      rowsPerPage : 20,
      filterOptionsLimit : 20,
      editModelOpen : false,
      deleteModelOpen : false,
      addressModelOpen : false,
      nameFilterInput: '',
      emailFilterInput: '',
      isUserVerifEditInput : '',
      statusEditInput : '',
      accessLevelEditInput : '',
      nameFilterOptions: [],
      emailFilterOptions: [],
      isUserVerifEditOptions: [],
      statusEditOptions : [],
      AccessLevelEditOptions : [],
      nameFilterLoading: false,
      emailFilterLoading: false,
      filterData : {},
      editData : {},
      deleteData : {},
    }
  }

  async componentDidMount(){
    if (mountLimit == 1){
      mountLimit++;
      try {
        const {result} = await apiCall('REACT_APP_GET_USER_URL', 'POST', {
          limit : this.state.rowsPerPage,
          skip : 0,
        })
        if (result && result['success'] && result['status']){
          let modifyData = await this.modifyApiData(result.status)
          this.setState({usersData : modifyData, totalSize : await result.totalSize});
          toast.success(result.msg);
        }
      } catch (error) {
        console.log('Category componentDidMount Error ::', error);
      }
      setTimeout(() => {
        mountLimit--;
      }, 500);
    }
  }

  async modifyApiData(rawDataArray) {
    return await rawDataArray.map( (data) =>{
      data['name'] = [data.firstName, data.lastName].join(' ');
      data.createdAt = new Date(data.createdAt).toLocaleString();
      data.updatedAt = new Date(data.updatedAt).toLocaleString();
      if (data.accessLevel == 1){
        data.accessLevel = 'super'
      } else if (data.accessLevel == 2){
        data.accessLevel = 'admin'
      } else if (data.accessLevel == 3){
        data.accessLevel = 'seller'
      } else if (data.accessLevel == 4){
        data.accessLevel = 'user'
      }

      if (data.status == 0){
        data.status = 'deleted'
      } else if (data.status == 1){
        data.status = 'active'
      } else if (data.status == 2){
        data.status = 'inactive'
      } else if (data.status == 3){
        data.status = 'autoDeleted'
      }

      if (data.isUserVerified == 1){
        data.isUserVerified = 'yes'
      } else {
        data.isUserVerified = 'no'
      }
      data['operationEditDelete'] = data.id

      return data;
    })
  }

  editModel = (data) => {
    let editData = this.state.editData;
    editData['userId'] = data.id;
    editData['firstName'] = data.firstName;
    editData['lastName'] = data.lastName;

    if (data.accessLevel == 'super'){
      editData['accessLevel'] = 1;
    } else if (data.accessLevel == 'admin'){
      editData['accessLevel'] = 2;
    } else if (data.accessLevel == 'seller'){
      editData['accessLevel'] = 3;
    } else if (data.accessLevel == 'user'){
      editData['accessLevel'] = 4;
    } 

    if (data.status == 'deleted'){
      editData['status'] = 0;
    } else if (data.status == 'active'){
      editData['status'] = 1;
    } else if (data.status == 'inactive'){
      editData['status'] = 2;
    } else if (data.status == 'autoDeleted'){
      editData['status'] = 3;
    } 

    if (data.isUserVerified == 'no'){
      editData['isUserVerified'] = 0;
    } else if (data.isUserVerified == 'yes'){
      editData['isUserVerified'] = 1;
    }

    this.setState({editData, editModelOpen : true})
  }
  deleteEntry = (data) => {
    let deleteData = this.state.deleteData;
    deleteData['userId'] = data.id
    this.setState({deleteData, deleteModelOpen : true})
  }
  openAddress = async (data) => {

    const {result} = await apiCall('REACT_APP_GET_USER_ADDRESS', 'POST', {
      userId : data.id,
    })
    if (result){
      this.setState({
        userAddresses : result.status,
        addressModelOpen : true,
      })
    }
  }

  formatData = async (data, value, label) => {
    return await data.map( (eachData) =>{
      let obj = {};
      obj['value'] = eachData[value];
      if (label == 'name'){
        obj['label'] = [eachData['firstName'], eachData['lastName']].join(' ');
      } else {
        obj['label'] = eachData[label];
      }
      return obj;
    })
  }
  handleChange = async (event, state, stateEdit, stateCreate) => {
    if (!Array.isArray(event)){
      event = [event] 
    }
    if (stateEdit){
      let editData = this.state.editData;
      await event.forEach( data => editData[stateEdit] = (data.value));
      this.setState({editData})
    } else if (stateCreate){
      let createData = this.state.createData;
      createData[stateCreate] = ''
      await event.forEach( data => createData[stateCreate] = (data.value));
      this.setState({createData})
    }else {
      let filterData = this.state.filterData;
      filterData[state] = []
      await event.forEach( data => filterData[state].push(data.value));
      this.setState({filterData})
    }
  }

  handleNameInputChange = async (nameFilterInput, { action }) => {
    this.setState({ nameFilterLoading: true })
    let input;
    let nameFilterOptions = []
    if (action === 'set-value') {
      input = this.state.nameFilterInput
    } else {
      input = nameFilterInput
      this.setState({ nameFilterInput })
    }
    if (input.split('').length >= 3){
      const {result} = await apiCall('REACT_APP_GET_USER_URL', 'POST', {
        textToSearch : input,
        limit : this.state.filterOptionsLimit
      })
      if (result && result.success){
        nameFilterOptions = await this.formatData(result.status, 'id', 'name')
      }
    }

    this.setState({ nameFilterOptions, nameFilterLoading: false })
  }
  handleEmailInputChange = async (emailFilterInput, { action }) => {
    this.setState({ emailFilterLoading: true })
    let input;
    let emailFilterOptions = []
    if (action === 'set-value') {
      input = this.state.emailFilterInput
    } else {
      input = emailFilterInput
      this.setState({ emailFilterInput })
    }
    if (input.split('').length >= 1){
      const {result} = await apiCall('REACT_APP_GET_USER_URL', 'POST', {
        textToSearch : input,
        limit : this.state.filterOptionsLimit
      })
      if (result && result.success){
        emailFilterOptions = await this.formatData(result.status, 'id', 'email')
      }
    }

    this.setState({ emailFilterOptions, emailFilterLoading: false })
  }  
  handleisUserVerifEditInputChange = async (isUserVerifEditInput, { action }) => {
    let input;
    let isUserVerifEditOptions = [
      { value: 0, label: 'no' },
      { value: 1, label: 'yes' }
    ]
    if (action === 'set-value') {
      input = this.state.isUserVerifEditInput
    } else {
      input = isUserVerifEditInput
      this.setState({ isUserVerifEditInput })
    }

    this.setState({ isUserVerifEditOptions})
  }
  handleStatusEditInputChange = async (statusEditInput, { action }) => {
    let input;
    let statusEditOptions = [
      { value: 0, label: 'deleted' },
      { value: 1, label: 'active' },
      { value: 2, label: 'inactive' },
      { value: 3, label: 'autoDeleted' },
    ]
    if (action === 'set-value') {
      input = this.state.statusEditInput
    } else {
      input = statusEditInput
      this.setState({ statusEditInput })
    }

    this.setState({statusEditOptions})
  }
  handleAccessLevelEditInputChange = async (accessLevelEditInput, { action }) => {
    let input;
    let AccessLevelEditOptions = [
      { value: 2, label: 'admin' },
      { value: 3, label: 'seller' },
      { value: 4, label: 'user' },
    ]
    if (action === 'set-value') {
      input = this.state.accessLevelEditInput
    } else {
      input = accessLevelEditInput
      this.setState({ accessLevelEditInput })
    }

    this.setState({AccessLevelEditOptions})
  }

  submitFilter = async (filterData) => {
    Object.keys(filterData).forEach((data)=>{
      if (filterData[data] == [] || filterData[data] == {} || filterData[data] == ''){
        delete filterData[data];
      }
    })
    filterData['skip'] = 0;
    filterData['limit'] = this.state.rowsPerPage || 20;
    const {result} = await apiCall('REACT_APP_GET_USER_URL', 'POST', filterData)
    if (result && result['success'] && result['status']){
      let modifyData = await this.modifyApiData(result.status)
      this.setState({usersData : modifyData, totalSize : await result.totalSize});
      toast.success(result.msg);
    }
  }
  submitEditForm = async (editData) => {
    Object.keys(editData).forEach((data)=>{
      if (editData[data] == [] || editData[data] == {} || editData[data] == ''){
        delete editData[data];
      }
    })
    if (Object.keys(editData).length == 0){
      return;
    }
    const {result} = await apiCall('REACT_APP_UPDATE_USER_URL', 'POST', editData)
    if (result && result['success'] && result['status']){
      this.setState({editModelOpen : false})
      this.submitFilter(this.state.filterData);
      toast.success(result.msg);
    }
  }
  submitDeleteForm = async (deleteData) => {
    Object.keys(deleteData).forEach((data)=>{
      if (deleteData[data] == [] || deleteData[data] == {} || deleteData[data] == ''){
        delete deleteData[data];
      }
    })
    if (Object.keys(deleteData).length == 0){
      return;
    }
    const {result} = await apiCall('REACT_APP_CHANGE_STATUS_USER_URL', 'POST', deleteData)
    if (result && result['success'] && result['status']){
      this.setState({deleteModelOpen : false})
      this.submitFilter(this.state.filterData);
      toast.success(result.msg);
    }
  }
  handleChangePage = async (chnagedPage, rowsPerPage) => {
    let filterData = this.state.filterData;
    let skippedEmptyArrayOfObj = [];
    Object.keys(filterData).forEach((data)=>{
      if (filterData[data] == [] || filterData[data] == {} || filterData[data] == ''){
        delete filterData[data];
      }
    })
    filterData['skip'] = chnagedPage * rowsPerPage || 0;
    filterData['limit'] = rowsPerPage || 20;
    for (let i=0; i<filterData['skip']; i++){
      skippedEmptyArrayOfObj.push({});
    }
    const {result} = await apiCall('REACT_APP_GET_USER_URL', 'POST', filterData)
    if (result && result['success'] && result['status']){
      let modifyData = await this.modifyApiData(result.status)
      this.setState({usersData : [...skippedEmptyArrayOfObj, ...modifyData],rowsPerPage : rowsPerPage, totalSize : await result.totalSize});
      return true;
    }
    return false;
  }

  render() {
    return (
      <React.Fragment>
        <Container
          headerName = "Users Manager"
          navPosition = "4"
        >
          <div id="filterDiv" style={{
            display : 'flex',
            justifyContent : 'space-between',
            width : '100%',
            minHeight : filterHeight, 
            border : 'none',
          }}>
            <div id="filterSelectDiv1">
              <ReactSelect
                label = {'Name'}
                placeholder = {'Search By Name'}
                inputValue = {this.state.nameFilterInput}
                onInputChange = {this.handleNameInputChange}
                options = {this.state.nameFilterOptions}
                stateFilterName = {'id'}
                onChange = {this.handleChange}
                isLoading = {this.state.nameFilterLoading}
                isMulti = {true}
              />
              <ReactSelect
                label = {'Email'}
                placeholder = {'Seach By Email'}
                inputValue = {this.state.emailFilterInput}
                onInputChange = {this.handleEmailInputChange}
                options = {this.state.emailFilterOptions}
                stateFilterName = {'id'}
                onChange = {this.handleChange}
                isLoading = {this.state.emailFilterLoading}
                isMulti = {true}
              />
            </div>
            <div style={{
              display : 'flex',
              flexDirection : 'row',
              gap : '10px',
              alignItems : 'center',
              justifyContent : 'center',
            }}>
              <ButtonSuccess
                style={{
                  display : 'flex',
                  flexDirection : 'row',
                  gap : '5px',
                  alignItems : 'center',
                  height : '28px',
                  padding : '7px 10px'
                }}
                onClick={()=>{this.submitFilter(this.state.filterData)}}
              >
                <span id="filterButtonStyle">FILTER</span>
                <FilterAltIcon sx={{width : '15px'}}/>
              </ButtonSuccess>
              {/* <ButtonSuccess
                style={{
                  display : 'flex',
                  flexDirection : 'row',
                  gap : '5px',
                  alignItems : 'center',
                  height : '28px',
                  padding : '7px 10px'
                }}
                onClick={()=>{this.setState({createData : {},createModelOpen:true})}}
              >
                CREATE
                <AddCircleIcon sx={{width : '15px'}}/>
              </ButtonSuccess> */}
            </div>
          </div>
          <Table
            columns={columns || []}
            dataValues={this.state.usersData || []}
            totalSize={this.state.totalSize || 0}
            filterHeight = {filterHeight}
            rowsPerPage = {this.state.rowsPerPage}
            handleChangePage = {this.handleChangePage}
            editModel={this.editModel}
            openAddress={this.openAddress}
            deleteEntry={this.deleteEntry}
          />
        </Container>

        {/* EDIT MODEL */}
        <Model
          title={'Edit User'}
          modelOpen={this.state.editModelOpen}
          maxWidth={"800px"}
        >
          <Form>
            <FormRow>
              <FormColumn>
                <FormInputLabel>
                  First Name
                </FormInputLabel>
                <FormInput
                  type="text"
                  required={true}
                  value={this.state.editData.firstName}
                  placeholder="First Name"
                  onChange={(e)=>{this.handleChange(e.target, '', 'firstName')}}
                ></FormInput>
                <FormInputLabel>
                  Last Name
                </FormInputLabel>
                <FormInput
                  type="text"
                  required={true}
                  value={this.state.editData.lastName}
                  placeholder="Last Name"
                  onChange={(e)=>{this.handleChange(e.target, '', 'lastName')}}
                ></FormInput>
              </FormColumn>
              <FormColumn>
                <ReactSelect
                  label = {'Status'}
                  placeholder = {'Select Status'}
                  inputValue = {this.state.statusEditInput}
                  onInputChange = {this.handleStatusEditInputChange}
                  options = {this.state.statusEditOptions}
                  value = { 
                    (this.state.editData.status === 0)
                    ? {value : this.state.editData.status, label : 'deleted'}
                    : (this.state.editData.status === 1) 
                      ? {value : this.state.editData.status, label : 'active'}
                      : (this.state.editData.status === 2) 
                        ? {value : this.state.editData.status, label : 'inactive'}
                        : (this.state.editData.status === 3) 
                          ? {value : this.state.editData.status, label : 'autoDeleted'}
                          : false
                  }
                  stateEditName = {'status'}
                  onChange = {this.handleChange}
                  isMulti = {false}
                />
                <br style={{padding : '8px 0px'}}></br>
                <ReactSelect
                  label = {'Is User Verified'}
                  placeholder = {'yes or no'}
                  inputValue = {this.state.isUserVerifEditInput}
                  onInputChange = {this.handleisUserVerifEditInputChange}
                  options = {this.state.isUserVerifEditOptions}
                  value = { 
                    (this.state.editData.isUserVerified === 1)
                    ? {value : this.state.editData.isUserVerified, label : 'yes'}
                    : (this.state.editData.isUserVerified === 0) 
                      ? {value : this.state.editData.isUserVerified, label : 'no'}
                      : false}
                  stateEditName = {'isUserVerified'}
                  onChange = {this.handleChange}
                  isMulti = {false}
                />
              </FormColumn>
              <FormColumn>
                <ReactSelect
                  label = {'AccessLevel'}
                  placeholder = {'Select AccessLevel'}
                  inputValue = {this.state.accessLevelEditInput}
                  onInputChange = {this.handleAccessLevelEditInputChange}
                  options = {this.state.AccessLevelEditOptions}
                  value = { 
                    (this.state.editData.accessLevel === 1)
                    ? {value : this.state.editData.accessLevel, label : 'super'}
                    : (this.state.editData.accessLevel === 2) 
                      ? {value : this.state.editData.accessLevel, label : 'admin'}
                      : (this.state.editData.accessLevel === 3) 
                        ? {value : this.state.editData.accessLevel, label : 'seller'}
                        : (this.state.editData.accessLevel === 4) 
                          ? {value : this.state.editData.accessLevel, label : 'user'}
                          : false
                  }
                  stateEditName = {'accessLevel'}
                  onChange = {this.handleChange}
                  isMulti = {false}
                />
              </FormColumn>
            </FormRow>
            <ButtonWrapper>
            <Link
                style={{
                  textDecoration: "none",
                }}
                to={
                  '/admin/users'
                }
              >
                <ButtonSecondary onClick={()=>{this.setState({editModelOpen:false})}}>
                  Cancel
                </ButtonSecondary>
              </Link>
              <Link
                style={{
                  textDecoration: "none",
                }}
                to={
                  '/admin/users'
                }
              >
                <ButtonSuccess
                  style={{
                    marginLeft: "10px",
                    textDecoration: "none",
                  }}
                  onClick={()=>{this.submitEditForm(this.state.editData)}}
                >
                  Submit
                </ButtonSuccess>
              </Link>
            </ButtonWrapper>
          </Form>
        </Model>

        {/* DELETE MODEL */}
        <Model
          title={'Delete Number'}
          modelOpen={this.state.deleteModelOpen}
        >
          <Form>
            <SubHeading>
              Are you sure, do you want to delete this user data ?
            </SubHeading>  
            <ButtonWrapper>
            <Link
                style={{
                  textDecoration: "none",
                }}
                to={
                  '/admin/users'
                }
              >
                <ButtonSecondary onClick={()=>{this.setState({deleteModelOpen:false})}}>
                  Cancel
                </ButtonSecondary>
              </Link>
              <Link
                style={{
                  textDecoration: "none",
                }}
                to={
                  '/admin/users'
                }
              >
                <ButtonSuccess
                  style={{
                    marginLeft: "10px",
                    textDecoration: "none",
                  }}
                  onClick={()=>{this.submitDeleteForm(this.state.deleteData)}}
                >
                  Submit
                </ButtonSuccess>
              </Link>
            </ButtonWrapper>
          </Form>
        </Model>


        {/* ADDRESS MODEL */}
        <Model
          title={'User Addresses'}
          modelOpen={this.state.addressModelOpen}
        >
          <Form>
              <Table
              columns={addressColumns || []}
              dataValues={this.state.userAddresses || []}
              totalSize={this.state.userAddresses.length || 0}
              // filterHeight = {filterHeight}
              // rowsPerPage = {this.state.rowsPerPage}
              // handleChangePage = {this.handleChangePage}
              // editModel={this.editModel}
              // openAddress={this.openAddress}
              // deleteEntry={this.deleteEntry}
            /> 
            <ButtonWrapper>
              <Link
                style={{
                  textDecoration: "none",
                }}
                to={
                  '/admin/users'
                }
              >
                <ButtonSecondary onClick={()=>{this.setState({addressModelOpen:false})}}>
                  Cancel
                </ButtonSecondary>
              </Link>
            </ButtonWrapper>
          </Form>
        </Model>
      </React.Fragment>
    );
  }

}

const mapStateToProps = (state) => {
  return { state }
}

export default connect(mapStateToProps)(Users);
